<header class="modal-header cambiar-contra-bg">
  <figure class="modal-title text-center w-100 p-5">
    <img src="../../../../../assets/images/cambiar-contra.png" width="100" />
  </figure>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span class="text-white" aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body text-center pl-5 pr-5 pb-5">
  <label class="h5 text-body"><strong>¡Listo!</strong></label>
  <p class="text-muted">Su contraseña ha sido cambiada satisfactoriamente.
      Por favor inicie sesión nuevamente:
      </p>
  <button class="btn btn-primary" (click)="confirm()">Iniciar</button>
</section>
